import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { flashUpdates } from "@/mocks/home";

const statusStyle: Record<string, string> = {
  已核实: "bg-accent-100 text-accent-900",
  跟进中: "bg-secondary-100 text-secondary-900",
  待核实: "bg-primary-100 text-primary-700",
};

export default function FlashTimeline() {
  return (
    <section id="flash" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="快讯流"
            title="黑料平台快讯流，更新节奏看得见"
            description="以时间线呈现最新动态，每条内容都带热度与核实状态，滚动查看即可把握平台当天的更新脉络。"
          />
        </Reveal>

        <div className="mt-12 flex flex-col gap-10 lg:flex-row lg:gap-12">
          <Reveal className="lg:w-64 lg:shrink-0">
            <div className="rounded-lg border border-background-200 bg-background-100/60 p-5">
              <div className="flex items-center gap-2 text-xs font-semibold text-primary-600">
                <span className="flex h-2 w-2 items-center justify-center">
                  <span className="h-2 w-2 animate-soft-pulse rounded-full bg-primary-500" />
                </span>
                实时滚动中
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                话题热度实时监测，榜单约每十分钟刷新一次，核实状态会随进展同步更新。
              </p>
              <div className="mt-5 space-y-3 border-t border-background-200 pt-4 text-xs text-foreground-500">
                <div className="flex items-center justify-between">
                  <span>榜单刷新</span>
                  <span className="font-medium text-foreground-800">10 分钟</span>
                </div>
                <div className="flex items-center justify-between">
                  <span>热点监测</span>
                  <span className="font-medium text-foreground-800">实时</span>
                </div>
                <div className="flex items-center justify-between">
                  <span>专题更新</span>
                  <span className="font-medium text-foreground-800">随话题进展</span>
                </div>
              </div>
            </div>
          </Reveal>

          <div className="relative flex-1">
            <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300" aria-hidden />
            <ul className="space-y-6">
              {flashUpdates.map((item, index) => (
                <Reveal key={`${item.time}-${item.title}`} delay={index * 60}>
                  <li className="relative pl-8">
                    <span className="absolute left-0 top-1.5 flex h-4 w-4 items-center justify-center rounded-full border border-background-300 bg-background-50">
                      <span
                        className={`h-2 w-2 rounded-full ${
                          item.status === "已核实"
                            ? "bg-accent-500"
                            : item.status === "跟进中"
                              ? "bg-secondary-500"
                              : "bg-primary-500"
                        }`}
                      />
                    </span>
                    <div className="flex flex-col gap-2 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100/50 md:flex-row md:items-center md:justify-between md:gap-6">
                      <div className="flex flex-1 flex-col gap-2 md:flex-row md:items-center md:gap-5">
                        <span className="font-heading text-sm font-bold text-foreground-400 md:w-14 md:shrink-0">
                          {item.time}
                        </span>
                        <div className="min-w-0">
                          <div className="flex flex-wrap items-center gap-2">
                            <span className="rounded-full bg-background-200 px-2.5 py-0.5 text-xs text-foreground-700">
                              {item.tag}
                            </span>
                            <span
                              className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${
                                statusStyle[item.status] ?? "bg-secondary-100 text-secondary-900"
                              }`}
                            >
                              {item.status}
                            </span>
                          </div>
                          <p className="mt-2 text-sm leading-relaxed text-foreground-900">
                            {item.title}
                          </p>
                        </div>
                      </div>
                      <span className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600">
                        <i className="ri-fire-line" />
                        {item.heat}
                      </span>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}